import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-our-apps',
  standalone: true,
  imports: [],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './our-apps.component.html',
  styleUrl: './our-apps.component.scss'
})
export class OurAppsComponent {
  [key: string]: any;
  constructor(
    private router:Router
  ){}

  
  goTo(link:any){
    this.router.navigate([link])
  }
}
